module.exports = __webpack_public_path__ + "img/logo_hlrs-300x150.f3cb499b.png";